import { Container } from './Container';

interface PageHeroPhoto {
  src1600: string;
  src800: string;
  alt: string;
  objectPosition?: string;
}

interface PageHeroProps {
  eyebrow: string;
  title: string;
  lead?: string;
  photo?: PageHeroPhoto;
}

export function PageHero({ eyebrow, title, lead, photo }: PageHeroProps): JSX.Element {
  return (
    <section
      className={
        photo
          ? 'relative isolate flex min-h-[55vh] items-center overflow-hidden bg-brand-charcoal text-brand-white'
          : 'bg-brand-charcoal py-16 text-brand-white md:py-20'
      }
    >
      {photo ? (
        <>
          <picture>
            <source
              type="image/webp"
              srcSet={`${photo.src800} 800w, ${photo.src1600} 1600w`}
              sizes="100vw"
            />
            <img
              src={photo.src1600}
              alt={photo.alt}
              className="absolute inset-0 -z-10 h-full w-full object-cover opacity-90"
              style={{ objectPosition: photo.objectPosition ?? 'center 60%' }}
              loading="eager"
              fetchPriority="high"
            />
          </picture>
          <div
            className="absolute inset-0 -z-10 bg-gradient-to-b from-brand-black/55 via-brand-black/40 to-brand-black/70"
            aria-hidden="true"
          />
        </>
      ) : null}
      <Container className={photo ? 'py-20 md:py-24' : ''}>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-brand-yellow">
          {eyebrow}
        </p>
        <h1 className="text-display-md font-bold tracking-heading-display text-brand-white md:text-display-lg">
          {title}
        </h1>
        {lead ? (
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-white/85 md:text-lg">
            {lead}
          </p>
        ) : null}
      </Container>
    </section>
  );
}
